import moment from 'moment';
import {isString} from 'lodash';
import {reverseDate, noTimeZoneShortISODate} from '../common/constants/datesFormat';

const BASE_FORM = {
  'sscCode': 'Código SSC',
  'campaingName': 'Nombre de campaña de servicio',
  'detail': 'Detalle',
};

export const errorFields = () => {
  return {
    ...BASE_FORM,
  };
};

const validateFieldsForm = (campaignFields, errorFields) => {
  let error = {
    'field': '',
    'error': false,
  };
  const errorArr = Object.keys(errorFields);
  errorArr.forEach((errorName) => {
    const field = campaignFields[errorName];
    const selectField = isNaN(field) === false ? `${field}` : field;
    if (!selectField) {
      error = {
        'field': errorFields[errorName],
        'error': true,
      };
    }
  });

  return error;
};

export const validateErrors = (campaign) => {
  const fieldsForm = errorFields();
  const validateForm = validateFieldsForm(campaign, fieldsForm);

  if (validateForm.error) {
    return {
      'error': true,
      'message': `El campo ${validateForm.field} es requerido`,
    };
  }

  return {
    'error': false,
    'message': null,
  };
};

const parseRawValue = (value) => {
  if (value && isString(value)) {
    return value.trim().toUpperCase();
  }

  return '';
};

const parseRawDateValue = (value) => {
  if (value) {
    const date = isString(value) ? value : String(value);
    const dateString = date.trim();

    if (dateString.length < 9) {
      return moment(dateString, reverseDate).format(noTimeZoneShortISODate);
    }
  }

  return '';
};

export const parseFileData = (data) => {
  return data.map((item) => {
    const result = {
      'modelName': parseRawValue(item[2]),
      'katashiki': parseRawValue(item[3]),
      'chassis': parseRawValue(item[4]),
      'createDate': parseRawDateValue(item[5]),
    };

    for (let i = 1; i < 10; i++) {
      const element = item[5 + i] || '';
      result[`partNo${i}`] = parseRawValue(element);
    }

    return result;
  });
};

export const sortDealersNames = (dealersArray) => {
  const sortDealersNames = [...dealersArray];
  return sortDealersNames.sort((a, b) => a.dealerName.localeCompare(b.dealerName));
};

export const validateUnique = (arr, field, value) => {
  const searchElement = arr.find((item) => item[field] === value);
  return typeof searchElement === 'undefined' ? true : false;
};

export const validateUniqueTask = (arr, taskId) => {
  const searchElement = arr.find(
    (item) => item.taskId === taskId
  );
  return typeof searchElement === 'undefined' ? true : false;
};

const urltoFile = async(url, filename, mimeType) => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, {'type': mimeType});
};

export const convertBase64ToFiles = (attachments) => {
  return Promise.all(attachments.map((item) => {
    const base64 = `data:image/jpeg;base64, ${item.file}`;
    return urltoFile(base64, item.name, item.mimetype);
  }));
};

export const parseChassisValues = (chassisList) => {
  return chassisList.map((element, index) => {
    return {'key': index, 'text': element.chassis, 'value': element.chassis};
  });
};

export const parsePartsForOrders = (partsArray) => {
  return partsArray.map((part) => {
    return {
      'minStock': part.minStock,
      'flagMinStock': part.flagMinStock,
      'availableStock': part.availableStock,
      'onOrder': part.onOrder,
      'onOrderConfirmed': part.onOrderConfirmed,
      'campaingNo': part.campaingNo,
      'dealersStock': part.dealersStock,
      'name': part.partName,
      'partCode': part.partno,
      'partQuantity': 0,
    };
  });
};

export const parseCampaignOptions = (campaignList = []) => {
  const additionalOptions = [{'text': 'TODOS', 'value': 'TODOS'}];

  const campaignListParsed = campaignList.map((campaign, index) => {
    return {
      'key': index,
      'text': `${campaign.campaingName}`,
      'value': campaign.campaingNo,
    };
  });

  return additionalOptions.concat(campaignListParsed);
};

export const buildParameters = (filters) => {
  const {
    attendedDealer,
    asignedDealer,
    campaignNo,
    startDate,
    endDate,
    taskId,
    status,
  } = filters;
  
  const parameters = {
    'startDate': startDate ? moment(startDate).format(noTimeZoneShortISODate) : null,
    'endDate': endDate ? moment(endDate).format(noTimeZoneShortISODate) : null,
    attendedDealer,
    asignedDealer,
    campaignNo,
    taskId,
    status,
  };

  Object.keys(parameters).forEach((key) => {
    if (!parameters[key]) {
      delete parameters[key];
    }
  });
  return parameters;
};
